import { Injectable } from "@angular/core";
import { environment } from "@src/environments/environment";
import * as msal from "@azure/msal-browser";
import { IFolder, IFolderAddResult, sp } from "@pnp/sp/presets/all";
import { from, lastValueFrom } from 'rxjs';

import "@pnp/sp/webs";
import "@pnp/sp/files";
import "@pnp/sp/folders";
import { HttpClient, HttpHeaders } from "@angular/common/http";

@Injectable({
    providedIn: 'root'
})
export class PowerAutomateService {
    // Esta variable aloja el sitio de Sharepoint que se quiere usar
    // Idealmente definir en el componente padre de la aplicación 
    // Ejemplo: acr.component.ts
    baseUrl: string;
    private msalInstance: msal.PublicClientApplication;
    environmentPro: boolean = environment.production;

    constructor(private http: HttpClient) {

        // Set up the MSAL configuration based on the selected environment
        const msalConfig = {
            auth: {
                clientId: environment.clientID,
                authority: `https://login.microsoftonline.com/${environment.tenantID}`,
                redirectUri: environment.redirectUrl,
            }
        };

        // Initialize the MSAL instance
        this.msalInstance = new msal.PublicClientApplication(msalConfig);

    }


    // Carlos ha comentado esto porque no se estaba utilizando y hemos quitado el secretId del front
    // getToken() {
    //     const url = `https://login.microsoftonline.com/5b973f99-77df-4beb-b27d-aa0c70b8482c/oauth2/v2.0/token`;

    //     const body = new URLSearchParams({
    //         client_id: environment.clientID,
    //         client_secret: environment.secretID,
    //         scope: 'https://service.flow.microsoft.com//.default',
    //         grant_type: 'client_credentials',
    //     });

    //     return this.http.post(url, body.toString(), {
    //         headers: new HttpHeaders({
    //             'Content-Type': 'application/x-www-form-urlencoded',
    //         }),
    //     });
    // }

    getConfigInfo() {
        // Configuración en producción
        if (environment.envType === 'production' || environment.envType === 'development' || environment.envType === 'preproduction') {

            sp.setup({
                sp: {
                    // la 'baseUrl' debe ser la url home de un sitio de sharepoint
                    // El resto de variables en esta función son estáticas y no deben ser cambiadas
                    baseUrl: this.baseUrl,
                    fetchClientFactory: () => {
                        let isInit = false;
                        return {
                            fetch: async (url: string, options: any) => {
                                const tokenRequest = {
                                    scopes: ["https://service.flow.microsoft.com//.default"]
                                };

                                if (!isInit) {
                                    await this.msalInstance.initialize();
                                    isInit = true;
                                }


                                const response = await this.msalInstance.acquireTokenSilent(tokenRequest);
                                console.log(response)
                                options.headers.set('Authorization', 'Bearer ' + response.accessToken);
                                return fetch(url, options);
                            }
                        };
                    }
                }
            });
            return sp;
        } else {
            const mySP = sp.configure(
                {
                    headers: {
                        accept: "application/json;odata=verbose",
                    },
                },
                'http://localhost:8080/'
            );
            return mySP;
        }
    }
}